import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";

export interface TransformerData {
 // No: any;
  TransformerID: any;
  SiteName: any;
  //LoadDetails: any;
  TypeRating: any;
  Communication: any;
  LastUpdatedTime: any;
 // Voltage: any;
 // Current: any;
  Status: any;
}

@Component({
  selector: "app-popuptable",
  templateUrl: "./popuptable.component.html",
  styleUrls: ["./popuptable.component.scss"],
})
export class PopuptableComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ELEMENT_DATA: TransformerData[] = [];
  displayedColumns: string[] = [
   // "No",
    "TransformerID",
    "SiteName",
    //"LoadDetails",
    "TypeRating",
    "Communication",
    "LastUpdatedTime",
   // "Voltage",
   // "Current",
    "Status",
  ];
  dataSource;
  alertsData;
  loadPercentage;
  constructor(
    private router: Router,private dialogRef: MatDialogRef<DashboardComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    console.log("received data", this.data);
    this.popupData();
  }
  popupData() {
    if (this.data.type == "total") {
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (
          this.data.TransformerData.result[i].datareceivedafter != true &&
          this.data.TransformerData.result[i].datareceivedafter != false
        ) {
          let jsonReadings = JSON.parse(
            this.data.TransformerData.result[i].transformerData.readings
          );
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      console.log("uhsakdshsdkjsa", this.loadPercentage);
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].alert.length > 0) {
          console.log(
            "JSONDATAREADINGS",
            this.data.TransformerData.result[i].transformerData.readings
          );

          let jsonData = JSON.parse(
            this.data.TransformerData.result[i].transformerData.readings
          );
          imgUrl = "assets/images/red_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageYPhase = jsonData.Y_Ph_N;
          voltageBPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;
        } else if (this.data.TransformerData.result[i].hasOwnProperty("datareceivedafter")) {
          imgUrl = "assets/images/black_transformer.png";
          signalUrl = 0;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
        } else if (this.data.TransformerData.result[i].alert == 0 && this.data.TransformerData.result[i].hasOwnProperty("datareceived")) {
          let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageBPhase = jsonData.Y_Ph_N;
          voltageYPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;
        }
        if (this.data.TransformerData.result[i].hasOwnProperty("transformerData")) {
          this.ELEMENT_DATA.push({
           // No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating:
              this.data.TransformerData.result[i].transformerData
                .kvarating,
            Communication: signalUrl,
            LastUpdatedTime:
              this.data.TransformerData.result[i].transformerData.latest_date,
          /*  Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
        if (this.data.TransformerData.result[i].hasOwnProperty("siteData") && !this.data.TransformerData.result[i].hasOwnProperty("transformerData")) {
          this.ELEMENT_DATA.push({
           // No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
           /* Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      console.log("ELEMEMT DATA", this.ELEMENT_DATA);
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;


    } else if (this.data.type == "online") {


      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push((((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) / 3 / this.data.TransformerData.result[i].transformerData.ratedLoad) * 100).toFixed(2));
        }
        else {
          this.loadPercentage.push(0);
        }
      }
      console.log("uhsakdshsdkjsa", this.loadPercentage);
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("transformerData")) {
          if (this.data.TransformerData.result[i].alert.length > 0) {

            console.log("JSONDATAREADINGS", this.data.TransformerData.result[i].transformerData.readings);
            let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
            imgUrl = "assets/images/red_transformer.png";
            signalUrl =1;
            voltageRPhase = jsonData.R_Ph_N;
            voltageYPhase = jsonData.Y_Ph_N;
            voltageBPhase = jsonData.B_Ph_N;
            currentRPhase = jsonData.L1;
            currentYPhase = jsonData.L2;
            currentBPhase = jsonData.L3;
            this.ELEMENT_DATA.push({
              //No: i + 1,
              TransformerID:
                this.data.TransformerData.result[i].siteData.transformerid,
              SiteName: this.data.TransformerData.result[i].siteData.sitename,
              //LoadDetails: this.loadPercentage[i],
              TypeRating:
                this.data.TransformerData.result[i].transformerData
                  .kvarating,
              Communication: signalUrl,
              LastUpdatedTime:
                this.data.TransformerData.result[i].transformerData.latest_date,
              /*Voltage: {
                RPhase: voltageRPhase,
                YPhase: voltageYPhase,
                BPhase: voltageBPhase,
              },
              Current: {
                RPhase: currentRPhase,
                YPhase: currentYPhase,
                BPhase: currentBPhase,
              },*/
              Status: imgUrl,
            });
          } else if (this.data.TransformerData.result[i].alert == 0 && this.data.TransformerData.result[i].hasOwnProperty("datareceived")) {
            console.log("JSONDATAREADINGS", this.data.TransformerData.result[i].transformerData.readings);
            let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
            imgUrl = "assets/images/green_transformer.png";
            signalUrl = 1;
            voltageRPhase = jsonData.R_Ph_N;
            voltageBPhase = jsonData.Y_Ph_N;
            voltageYPhase = jsonData.B_Ph_N;
            currentRPhase = jsonData.L1;
            currentYPhase = jsonData.L2;
            currentBPhase = jsonData.L3;
            this.ELEMENT_DATA.push({
              //No: i + 1,
              TransformerID:
                this.data.TransformerData.result[i].siteData.transformerid,
              SiteName: this.data.TransformerData.result[i].siteData.sitename,
              //LoadDetails: this.loadPercentage[i],
              TypeRating:
                this.data.TransformerData.result[i].transformerData
                  .kvarating,
              Communication: signalUrl,
              LastUpdatedTime:
                this.data.TransformerData.result[i].transformerData.latest_date,
              /*Voltage: {
                RPhase: voltageRPhase,
                YPhase: voltageYPhase,
                BPhase: voltageBPhase,
              },
              Current: {
                RPhase: currentRPhase,
                YPhase: currentYPhase,
                BPhase: currentBPhase,
              },*/
              Status: imgUrl,
            });
          }


        }

      }

      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if (this.data.type == "offline") {
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      console.log("uhsakdshsdkjsa", this.loadPercentage);
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("datareceivedafter")
        ) {
          imgUrl = "assets/images/black_transformer.png";
          signalUrl = 0;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if (this.data.type == "normal") {
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (
          this.data.TransformerData.result[i].datareceivedafter != true &&
          this.data.TransformerData.result[i].datareceivedafter != false
        ) {
          let jsonReadings = JSON.parse(
            this.data.TransformerData.result[i].transformerData.readings
          );
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      console.log("uhsakdshsdkjsa", this.loadPercentage);
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (
          this.data.TransformerData.result[i].alert == 0 &&
          this.data.TransformerData.result[i].hasOwnProperty("datareceived") &&
          this.data.TransformerData.result[i].hasOwnProperty("transformerData")
        ) {
          let jsonData = JSON.parse(
            this.data.TransformerData.result[i].transformerData.readings
          );
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageBPhase = jsonData.Y_Ph_N;
          voltageYPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;

          this.ELEMENT_DATA.push({
           // No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
           // LoadDetails: this.loadPercentage[i],
            TypeRating:
              this.data.TransformerData.result[i].transformerData
                .kvarating,
            Communication: signalUrl,
            LastUpdatedTime:
              this.data.TransformerData.result[i].transformerData.latest_date,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if (this.data.type == "alert") {
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push((((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) / 3 / this.data.TransformerData.result[i].transformerData.ratedLoad) * 100).toFixed(2));
        }
        else {
          this.loadPercentage.push(0);
        }
      }
      console.log("uhsakdshsdkjsa", this.loadPercentage);
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].alert.length > 0) {
          console.log("JSONDATAREADINGS", this.data.TransformerData.result[i].transformerData.readings);
          let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          imgUrl = "assets/images/red_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageYPhase = jsonData.Y_Ph_N;
          voltageBPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating:
              this.data.TransformerData.result[i].transformerData
                .kvarating,
            Communication: signalUrl,
            LastUpdatedTime:
              this.data.TransformerData.result[i].transformerData.latest_date,
           /* Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }

      }

      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.selected == "alertDataSelected"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false && this.data.TransformerData.result[i].alert.length > 0) {
          for(let j = 0;j<this.data.TransformerData.result[i].alert.length;j++){
            if(this.data.TransformerData.result[i].alert[j].parametername == this.data.type){
            let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
            this.loadPercentage.push((((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) / 3 / this.data.TransformerData.result[i].transformerData.ratedLoad) * 100).toFixed(2));
            }
          }
        }
        else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false && this.data.TransformerData.result[i].alert.length > 0) {
          for(let j = 0;j<this.data.TransformerData.result[i].alert.length;j++){
            if(this.data.TransformerData.result[i].alert[j].parametername == this.data.type){
          console.log("JSONDATAREADINGS", this.data.TransformerData.result[i].transformerData.readings);
          let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          imgUrl = "assets/images/red_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageYPhase = jsonData.Y_Ph_N;
          voltageBPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;
          this.ELEMENT_DATA.push({
           // No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating:
              this.data.TransformerData.result[i].transformerData
                .kvarating,
            Communication: signalUrl,
            LastUpdatedTime:
              this.data.TransformerData.result[i].transformerData.latest_date,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
        }
      }
      }
     /* const result = this.ELEMENT_DATA.filter(
        (thing, index, self) =>
          index ===
          self.findIndex((t) => t.TransformerID === thing.TransformerID)
      );*/

      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }  else if(this.data.selected == "helathCenterDataSelected"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false && this.data.TransformerData.result[i].alert.length > 0) {
          for(let j = 0;j<this.data.TransformerData.result[i].alert.length;j++){
            if(this.data.TransformerData.result[i].alert.length >= this.data.type){
            let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
            this.loadPercentage.push((((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) / 3 / this.data.TransformerData.result[i].transformerData.ratedLoad) * 100).toFixed(2));
            }
          }
        }
        else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false && this.data.TransformerData.result[i].alert.length > 0) {
          for(let j = 0;j<this.data.TransformerData.result[i].alert.length;j++){
            if(this.data.TransformerData.result[i].alert.length >= this.data.type){
          console.log("JSONDATAREADINGS", this.data.TransformerData.result[i].transformerData.readings);
          let jsonData = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          imgUrl = "assets/images/red_transformer.png";
          signalUrl = 1;
          voltageRPhase = jsonData.R_Ph_N;
          voltageYPhase = jsonData.Y_Ph_N;
          voltageBPhase = jsonData.B_Ph_N;
          currentRPhase = jsonData.L1;
          currentYPhase = jsonData.L2;
          currentBPhase = jsonData.L3;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating:
              this.data.TransformerData.result[i].transformerData
                .kvarating,
            Communication: signalUrl,
            LastUpdatedTime:
              this.data.TransformerData.result[i].transformerData.latest_date,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
        }
      }
      }
     /* const result = this.ELEMENT_DATA.filter(
        (thing, index, self) =>
          index ===
          self.findIndex((t) => t.TransformerID === thing.TransformerID)
      );*/

      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "Disconnected"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].deviceStatus == true ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("deviceStatus")
        ) {
          imgUrl = "assets/images/black_transformer.png";
          signalUrl = 0;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if (this.data.type == "Connected") {
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].deviceStatusConnected == false ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("deviceStatusConnected")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "Healthy"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].healthStatus == true ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("healthStatus")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "Average"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].AvghealthStatus == true ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("AvghealthStatus")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "Unhealthy"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].UnhealthStatus == true ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("UnhealthStatus")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "completeMaintenance"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].completeMaintenanceStatus == false ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("completeMaintenanceStatus")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else if(this.data.type == "pendingMaintenance"){
      this.loadPercentage = [];
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].pendingMaintenanceStatus == false ) {
          let jsonReadings = JSON.parse(this.data.TransformerData.result[i].transformerData.readings);
          this.loadPercentage.push(
            (
              ((jsonReadings.L1 + jsonReadings.L2 + jsonReadings.L3) /
                3 /
                this.data.TransformerData.result[i].transformerData.ratedLoad) *
              100
            ).toFixed(2)
          );
        } else {
          this.loadPercentage.push(0);
        }
      }
      let imgUrl;
      let signalUrl;
      let voltageRPhase;
      let voltageYPhase;
      let voltageBPhase;
      let currentRPhase;
      let currentYPhase;
      let currentBPhase;

      // console.log('offiline ',this.data.TransformerData.result.lenght.hasOwnProperty('datareceivedafter'))
      for (let i = 0; i < this.data.TransformerData.result.length; i++) {
        if (this.data.TransformerData.result[i].hasOwnProperty("pendingMaintenanceStatus")
        ) {
          imgUrl = "assets/images/green_transformer.png";
          signalUrl = 1;
          voltageRPhase = 0;
          voltageRPhase = 0;
          voltageBPhase = 0;
          voltageYPhase = 0;
          currentRPhase = 0;
          currentYPhase = 0;
          currentBPhase = 0;
          this.ELEMENT_DATA.push({
            //No: i + 1,
            TransformerID:
              this.data.TransformerData.result[i].siteData.transformerid,
            SiteName: this.data.TransformerData.result[i].siteData.sitename,
            //LoadDetails: this.loadPercentage[i],
            TypeRating: 0,
            Communication: signalUrl,
            LastUpdatedTime: 0,
            /*Voltage: {
              RPhase: voltageRPhase,
              YPhase: voltageYPhase,
              BPhase: voltageBPhase,
            },
            Current: {
              RPhase: currentRPhase,
              YPhase: currentYPhase,
              BPhase: currentBPhase,
            },*/
            Status: imgUrl,
          });
        }
      }
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }
  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }
  close() {
    this.dialogRef.close();
  }
  open_individual(TransformerID){
    // console.log(TransformerID)
    // this.router.navigate(['/#/individual-status/', { transformerId: TransformerID} ]);
  this.dialogRef.close();
    this.router.navigate(['digitalTwin/'], { queryParams: { transformerId: TransformerID } });

  }
  alertdata(transformerid){
    console.log("onhover");
    this.alertsData = "";
    for (let i = 0; i < this.data.TransformerData.result.length; i++) {
      if(this.data.TransformerData.result[i].siteData.transformerid == transformerid)
      if(this.data.TransformerData.result[i].alert.length > 0 && this.data.TransformerData.result[i].datareceivedafter != true && this.data.TransformerData.result[i].datareceivedafter != false){
        for(let j=0;j<this.data.TransformerData.result[i].alert.length;j++){
          this.alertsData += this.data.TransformerData.result[i].alert[j].parametername.replace("ap", "")+",";
        }
      }
    }
  }
}
